import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.module.scss';

export const Icons = (props) => {
  const { className, variant, onClick, testid } = props;

  const getIcons = () => {
    switch (variant) {
      case Icons.MENU: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <circle cx="5" cy="12" r="2" fill="#676767" />
            <circle cx="12" cy="12" r="2" fill="#676767" />
            <circle cx="19" cy="12" r="2" fill="#676767" />
          </svg>
        );
      }
      case Icons.PIN: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M9.66675 13.3333V16.6666"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.66667 9.17325C7.66653 9.42131 7.59721 9.66441 7.46648 9.87522C7.33575 10.086 7.14881 10.2562 6.92667 10.3666L5.74 10.9666C5.51786 11.077 5.33091 11.2471 5.20019 11.4579C5.06946 11.6688 5.00013 11.9119 5 12.1599V12.6666C5 12.8434 5.07024 13.013 5.19526 13.138C5.32029 13.263 5.48986 13.3333 5.66667 13.3333H13.6667C13.8435 13.3333 14.013 13.263 14.1381 13.138C14.2631 13.013 14.3333 12.8434 14.3333 12.6666V12.1599C14.3332 11.9119 14.2639 11.6688 14.1331 11.4579C14.0024 11.2471 13.8155 11.077 13.5933 10.9666L12.4067 10.3666C12.1845 10.2562 11.9976 10.086 11.8669 9.87522C11.7361 9.66441 11.6668 9.42131 11.6667 9.17325V6.66659C11.6667 6.48977 11.7369 6.32021 11.8619 6.19518C11.987 6.07016 12.1565 5.99992 12.3333 5.99992C12.687 5.99992 13.0261 5.85944 13.2761 5.60939C13.5262 5.35935 13.6667 5.02021 13.6667 4.66659C13.6667 4.31296 13.5262 3.97382 13.2761 3.72378C13.0261 3.47373 12.687 3.33325 12.3333 3.33325H7C6.64638 3.33325 6.30724 3.47373 6.05719 3.72378C5.80714 3.97382 5.66667 4.31296 5.66667 4.66659C5.66667 5.02021 5.80714 5.35935 6.05719 5.60939C6.30724 5.85944 6.64638 5.99992 7 5.99992C7.17681 5.99992 7.34638 6.07016 7.4714 6.19518C7.59643 6.32021 7.66667 6.48977 7.66667 6.66659V9.17325Z"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.UNPIN: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M9.6665 13.3333V16.6666"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.66667 9.17325C7.66653 9.42131 7.59721 9.66441 7.46648 9.87522C7.33575 10.086 7.14881 10.2562 6.92667 10.3666L5.74 10.9666C5.51786 11.077 5.33091 11.2471 5.20019 11.4579C5.06946 11.6688 5.00013 11.9119 5 12.1599V12.6666C5 12.8434 5.07024 13.013 5.19526 13.138C5.32029 13.263 5.48986 13.3333 5.66667 13.3333H13.6667C13.8435 13.3333 14.013 13.263 14.1381 13.138C14.2631 13.013 14.3333 12.8434 14.3333 12.6666V12.1599C14.3332 11.9119 14.2639 11.6688 14.1331 11.4579C14.0024 11.2471 13.8155 11.077 13.5933 10.9666L12.4067 10.3666C12.1845 10.2562 11.9976 10.086 11.8669 9.87522C11.7361 9.66441 11.6668 9.42131 11.6667 9.17325V6.66659C11.6667 6.48977 11.7369 6.32021 11.8619 6.19518C11.987 6.07016 12.1565 5.99992 12.3333 5.99992C12.687 5.99992 13.0261 5.85944 13.2761 5.60939C13.5262 5.35935 13.6667 5.02021 13.6667 4.66659C13.6667 4.31296 13.5262 3.97382 13.2761 3.72378C13.0261 3.47373 12.687 3.33325 12.3333 3.33325H7C6.64638 3.33325 6.30724 3.47373 6.05719 3.72378C5.80714 3.97382 5.66667 4.31296 5.66667 4.66659C5.66667 5.02021 5.80714 5.35935 6.05719 5.60939C6.30724 5.85944 6.64638 5.99992 7 5.99992C7.17681 5.99992 7.34638 6.07016 7.4714 6.19518C7.59643 6.32021 7.66667 6.48977 7.66667 6.66659V9.17325Z"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <rect
              y="13.4116"
              width="22"
              height="3.35953"
              rx="1.67977"
              transform="rotate(-37.5619 0 13.4116)"
              fill="white"
            />
            <path
              d="M2 13L15.6709 2.62159"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        );
      }
      case Icons.CLEAR: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M14.1668 14.1666L5.8335 5.83325"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M5.83317 14.1666L14.1665 5.83325"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        );
      }
      default: {
        return null;
      }
    }
  };

  return (
    <div testid={testid} onClick={onClick} className={classNames(styles.icons, className)}>
      {getIcons()}
    </div>
  );
};

Icons.PIN = 'pin';
Icons.UNPIN = 'unpin';
Icons.CLEAR = 'clear';
Icons.MENU = 'menu';

Icons.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
  testid: PropTypes.string,
  onClick: PropTypes.func,
};

Icons.defaultProps = {
  className: '',
  variant: '',
  testid: undefined,
  onClick: () => {},
};
